module.exports = __webpack_public_path__ + "img/s3.cba77cb0.png";